export const lineClampCollapsedSx = {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
}

export const toggleButtonSx = {
    cursor: "pointer",
    border: "none",
    background: "none",
    padding: 0,
    marginBottom: "4px",
    fontFamily: "inherit",
    textAlign: "left",
    "@media (hover: hover) and (pointer: fine)": {
        "&:hover": { textDecoration: "underline" },
    },
}